import { STORES, addItem, updateItem, getItemById } from '../../../db/indexedDB'

const AUTH_STORE_KEY = 'current_user'

/**
 * Save auth state to IndexedDB
 * @param {Object} user Firebase user object
 * @param {Object} agiliteUser Agilite user object
 */
export const saveAuthState = async (user, agiliteUser) => {
  try {
    const authState = {
      id: AUTH_STORE_KEY,
      firebaseUser: user
        ? {
            uid: user.uid,
            email: user.email,
            phoneNumber: user.phoneNumber,
            providerData: user.providerData,
            metadata: user.metadata
          }
        : null,
      agiliteUser: agiliteUser,
      lastUpdated: new Date().toISOString()
    }

    const existingState = await getItemById(STORES.AUTH, AUTH_STORE_KEY)
    if (existingState) {
      await updateItem(STORES.AUTH, authState)
    } else {
      await addItem(STORES.AUTH, authState)
    }
  } catch (error) {
    console.error('Error saving auth state:', error)
  }
}

/**
 * Get cached auth state from IndexedDB
 * @returns {Promise<Object>} Cached auth state
 */
export const getCachedAuthState = async () => {
  try {
    const authState = await getItemById(STORES.AUTH, AUTH_STORE_KEY)
    return authState
  } catch (error) {
    console.error('Error getting cached auth state:', error)
    return null
  }
}

/**
 * Clear auth state from IndexedDB
 */
export const clearAuthState = async () => {
  try {
    await saveAuthState(null, null)
  } catch (error) {
    console.error('Error clearing auth state:', error)
  }
}
